export enum ExperienceIssues {
  TooDifficultOrEasy = 'TOO_DIFFICULT_OR_EASY',
  StartedLateEndedEarly = 'STARTED_LATE_ENDED_EARLY',
  UnclearExplanations = 'UNCLEAR_EXPLANATIONS',
  TooFast = 'TOO_FAST',
  NotEngaging = 'NOT_ENGAGING',
  NoProgress = 'NO_PROGRESS',
  TutorNotSupportive = 'TUTOR_NOT_SUPPORTIVE',
  Other = 'OTHER',
}

export enum ConnectionIssues {
  VideoAudioIssues = 'VIDEO_AUDIO_ISSUES',
  FreezingOrLagging = 'FREEZING_OR_LAGGING',
  EchoOrBackgroundNoise = 'ECHO_OR_BACKGROUND_NOISE',
  GotDisconnected = 'GOT_DISCONNECTED',
  PlatformGlitchesOrErrors = 'PLATFORM_GLITCHES_OR_ERRORS',
  ScreenSharingIssues = 'SCREEN_SHARING_ISSUES',
}
